import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import obi from "../../static/images/Obi-Ikegulu.jpg"
import hardish from "../../static/images/Hardish-Wilkhu-.jpg"
import India from "../../static/images/India-bg.png"
import dapo from "../../static/images/dapo.png"
import jahswill from "../../static/images/jahswill2.png"
import feyi from "../../static/images/feyi.png"
import osmond from "../../static/images/osmond.png"
import website from "../../static/images/website.png"
import sinkopere from "../../static/images/sinkopere.png"
import aws_practitioner from "../../static/images/aws_practitioner.png"
import aws_security from "../../static/images/aws_security.png"
import aws_developer from "../../static/images/aws_developer.png"
import aws_solutions_architect from "../../static/images/aws_solutions_architect.png"
import aws_devops from "../../static/images/aws_devops.png"
import cka from "../../static/images/cka.png"

const AboutPage = () => (
  <Layout>
    <SEO title="About Us" />
    <div className="hero-section d-section">
      <div className="hero-wrapper other">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-h1">About Us</h1>
            <p className="hero-p">
              We are a group of engineers who love engineering and take pride in
              the work we do. We like to see DevOps done right and that is at
              the core of our passion.
            </p>
          </div>
          <div className="hero-content"></div>
        </div>
      </div>
    </div>
    <div className="section symbol-l border-bottom-0 pt-5">
      <div className="container text-left">
        <h1 className="section-title text-center">Who are we?  <p className="text-center text-dark">We make Cloud and DevOps adoption fast, secure and simple.</p></h1>
      
        <div class="row">
          <div class="col-md-6">
          
            <img src={website} className="img-fluid" alt="Obi img" />
            
  
          </div>
          <div class="col-md-6">
            <p className="p20">
            Established in 2019, <b className="text-primary">Cognetiks Consulting</b> is a leading provider of cloud
            advisory services, Cloud migration, DevOps and Automation and cloud 
            managed services to organizations
            </p>
            <p className="p20">
            With the understanding that the world is rapidly changing and 
            businesses are fast-evolving, Cognetiks Consulting was born out of the 
            passion to help businesses leverage the power of cloud technology 
            solutions to gain competitive advantage and stand out in their diverse 
            industries. 
            </p>
            <p className="p20">
            Whatever the company size; small business, start up or a large 
            enterprise, we are the strategic partner you need to modernize your IT 
            processes and accelerate your business operations by adopting the 
            best practices in devops and cloud technology. 
            </p>

          
          
          </div>

          <div className="col-md-12">


            <p className="p20">
            Cognetiks Consulting is a trusted  <b className="text-warning">Amazon Web Services </b> 
            partner, <b> <span className="text-primary">G</span><span className="text-danger">o</span><span className="text-warning">o</span><span className="text-primary">g</span><span className="text-success">l</span><span className="text-danger">e</span> Cloud</b> partner and Microsoft <b className="text-info">Azure</b>  partner. With a 
            proven history of helping global brands in the Energy, Government, 
            Healthcare, Financial services and Gambling sectors, we deploy the 
            finest tools in helping organizations adopt the power of cloud 
            computing. 
            </p>
            <p className="p20">Driven by Innovation and technology, our solutions are customer 
            centric, we collaborate with you to understand your business needs 
            and take your organization to the next level. Our experts are a team of
            dedicated professionals giving you round the clock support in your 
            cloud journey.
            </p>
          </div>


          {/* <div className="col-md-5">


            <p className="p20">Some of our expertise includes but not limited to: Cloud Architecture, 
            Artificial Intelligence, Infrastructure as code, Configuration 
            Management, CI/CD, Cloud migration (on-premise to cloud, cloud to 
            cloud, hybrid), Cost optimization, Containerization, Kubernetes, Server 
            less (Function as a service), Micro service Architecture, Database, 
            Management / Optimisation/analytics and Mobile Deployment.
            </p>
          </div>

          <div class="col-md-7">
          
            <img src={network} className="img-fluid" alt="Obi img" />
            
  
          </div> */}

          
          <div className="col-12 jumbotron why-section m-3 mr-5">
          <i>Some of our expertise includes but not limited to: Cloud Architecture, 
            Artificial Intelligence, Infrastructure as code, Configuration 
            Management, CI/CD, Cloud migration (on-premise to cloud, cloud to 
            cloud, hybrid), Cost optimization, Containerization, Kubernetes, Server 
            less (Function as a service), Micro service Architecture, Database, 
            Management / Optimisation/analytics and Mobile Deployment.</i>
          </div>
        </div>
       
      </div>
    </div>
    <div className="section border-bottom-0 pt-5 ">
      <div className="container ">
        <h2 className="section-title">Meet the team</h2>
        
        <div className="wrapper c ">
          <div className="team-wrapper img">
            <img src={obi} alt="Obi img" />
            <h2 className="team-name">Obi Ikegulu</h2>
            <h3 className="team-name">CEO & Co-Founder</h3>
          </div>
          <div className="team-wrapper t">
            <p className="p20 text-left">
              Obi is a highly experienced DevOps consultant with over 15 years
              of extensive IT Architecture and Management experience in a
              variety of market sectors, he has an in depth understanding of
              Cloud Architecture and Technology in conjunction with their
              related markets and strategies, marking himself as accomplished
              professional in designing, implementing and configuring a wide
              variety of Technologies such as Microservices, Cloud Architecture
              Integration, Application Development and Systems Solutions
              methodologies. Obi is currently focused on helping clients embrace
              Cloud Technologies showing them how it works and why it matters.
            </p>
            <a href="/about-us/#">
              <img src={aws_practitioner} alt="" />
            </a>
          </div>
        </div>
        <div className="wrapper c rev">
          <div className="team-wrapper t">
            <p className="p20 text-left">
              Having worked across a number of industries, including government,
              energy, gambling and finance, Hardish is a very adaptable engineer
              with a breadth of knowledge. Starting his career as a data
              engineer, he quickly found a passion for DevOps. He has worked
              with an array of companies to build cloud landscapes and introduce
              containerisation solutions. He is AWS certified and a certified
              kubernetes administrator.
            </p>
            <a href="https://www.youracclaim.com/badges/c811acd4-d67f-4dca-9c3c-892fbd0e5568/public_url">
              <img src={cka} alt="" />
            </a>
            <a href="https://www.certmetrics.com/amazon/public/badge.aspx?i=9&t=c&d=2020-01-18&ci=AWS00323435">
              <img src={aws_practitioner} alt="" />
            </a>
            <a href="https://www.certmetrics.com/amazon/public/badge.aspx?i=2&t=c&d=2018-05-25&ci=AWS00323435">
              <img src={aws_developer} alt="" />
            </a>
            <a href="https://www.certmetrics.com/amazon/public/badge.aspx?i=7&t=c&d=2020-02-18&ci=AWS00323435">
              <img src={aws_security} alt="" />
            </a>
          </div>
          <div className="team-wrapper img">
            {/* <img
              src="images/Hardish-Wilkhu-.jpg"
              srcSet="images/Hardish-Wilkhu--p-800.jpeg 800w, images/Hardish-Wilkhu-.jpg 900w"
              sizes="(max-width: 479px) 83vw, (max-width: 767px) 79vw, (max-width: 991px) 84vw, 43vw"
              alt=""
            /> */}
            <img src={hardish} alt="Hardish img" />
            <h2 className="team-name">Hardish Wilkhu</h2>
            <h3 className="team-name">CTO & Co-Founder</h3>
          </div>
        </div>

        <div className="wrapper c ">
          <div className="team-wrapper img">
            <img src={dapo} alt="dapo img" />
            <h2 className="team-name">Adedapo Adeyipo</h2>
            <h3 className="team-name">Senior Business Development Manager</h3>
          </div>
          <div className="team-wrapper t">
            <p className="p20 text-left">
            Adedapo, seasoned tech sales leader, drives customer-centric initiatives, excelling in strategic partnerships. With 7+ years' experience across Fintech, Information Technology (IT) industry, Mobility, and more, he elevates Cognetiks Consulting through adept sales strategies and key account management.
            </p>
          </div>
        </div>

        <div className="wrapper c rev">
          <div className="team-wrapper t">
            <p className="p20 text-left">
            
              India is an expert sales professional with 4 years experience in
              the information technology sales industry. She's got excellent
              communication and people skills, she's charismatic and a strong
              negotiator with a proven record of closing sales deals. Having
              developed commercial relationships with key customers and
              partners, India acts as an ambassador for Cognetiks Consulting.
              She supports all sales activities within the company, monitors and
              manages the performance of the sales department and area sales
              managers.
            </p>
          </div>
          <div className="team-wrapper img">
            <img src={India} alt="India img" />
            <h2 className="team-name">India O'Byrne</h2>
            <h3 className="team-name">Sales Director</h3>
          </div>
        </div>

        <div className="wrapper c">
          <div className="team-wrapper img">
            <img src={jahswill} alt="jahswill img" />
            <h2 className="team-name">Jahswill Ovedhe</h2>
            <h3 className="team-name">Software Engineer</h3>
          </div>
          <div className="team-wrapper t">
            <p className="p20 text-left">
            Jahswill is a self-motivated software engineer, with a high level 
            of experience working on multiple projects in the information technology and 
            services industry. He has an excellent understanding of development principles 
            from product conceptualization, to testing and evaluation. He is highly skilled in full-Stack 
            Web Development with Python and its frameworks and JavaScript. He also possesses good 
            knowledge of cloud technologies and development on the cloud, and an excellent understanding of DevOps principles.
            </p>
            <a href="https://www.credly.com/badges/c8fd4e1a-c6ba-4de1-bc39-e00a149540d9/public_url">
              <img src={aws_practitioner} alt="aws certification badge" />
            </a>
            <a href="https://www.credly.com/badges/48255622-7b60-4f75-b942-e5d58060da24/public_url">
              <img
                src={aws_solutions_architect}
                alt="aws certification badge"
              />
            </a>
            <a href="https://www.credly.com/badges/6e0a5967-ab5a-4fa0-a138-41b551c4c345">
              <img src={aws_developer} alt="aws certification badge" />
            </a>
          </div>
        </div>

        <div className="wrapper c rev">
          <div className="team-wrapper t">
            <p className="p20 text-left">
            Feyi Disu is a results-oriented sales professional with over 7 years of experience in the manufacturing and IT industry. 
            He’s highly skilled at creating new relationships and maintaining strong customer relations to generate repeat business. 
            He has in-depth knowledge of effective sales strategies and exceptional presentation skills. He is goal-oriented with 
            AWS business and Cloud economics certification.
            </p>
        
          </div>
          <div className="team-wrapper img">
            <img src={feyi} alt="Miracle img" />
            <h2 className="team-name">Feyi Disu</h2>
            <h3 className="team-name">Business Development Manager</h3>
          </div>
        </div>

        <div className="wrapper c ">
          <div className="team-wrapper img">
            <img src={sinkopere} alt="sinkopere img" />
            <h2 className="team-name">Sinkopere Opuba</h2>
            <h3 className="team-name">Technical Lead</h3>
          </div>
          <div className="team-wrapper t">
            <p className="p20 text-left">
              Sinkopere is a highly skilled developer with deep knowledge and
              experience in web, cloud, and serverless technologies and
              architectures. He's excited about learning new ways of solving
              business problems. He is currently focused on helping software
              engineering teams and IT organizations to streamline their
              workflows and follow best practices when architecting for the
              cloud.
            </p>
            <a href="https://www.youracclaim.com/badges/f861455f-b6ca-404e-9a1a-fbc3c2636d42/public_url">
              <img src={aws_practitioner} alt="aws certification badge" />
            </a>
            <a href="https://www.youracclaim.com/badges/07ebda8c-2f2a-4318-ac6d-2b4c133b2ee6/public_url">
              <img src={aws_developer} alt="aws certification badge" />
            </a>
            <a href="https://www.youracclaim.com/badges/49a96026-7f32-4e38-93a0-177226694895/public_url">
              <img
                src={aws_solutions_architect}
                alt="aws certification badge"
              />
            </a>
            <a href="https://www.credly.com/badges/6eb40f9b-48f6-4793-842a-0fe7d717a069/public_url">
              <img
                src={aws_devops}
                alt="aws certification badge"
              />
            </a>
          </div>
        </div>

        <div className="wrapper c rev">
          <div className="team-wrapper t">
            <p className="p20 text-left">
            Osmond is a goal oriented and result driven individual. He has a deep knowledge in digital marketing and social media management. 
            Osmond also has a knack for graphics designing. He's opened to learning new trends in the online sphere; exploring them for greater business growth. He is currently focused on helping brands build their image online.
            </p>
        
          </div>
          <div className="team-wrapper img">
            <img src={osmond} alt="Miracle img" />
            <h2 className="team-name">Osmond Anyaka </h2>
            <h3 className="team-name">Digital Marketer</h3>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default AboutPage
